<script>
const NAV_ICONS = {
  home: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.05 4.81774L12.29 0.78774C10.72 -0.31226 8.31 -0.252259 6.8 0.917741L1.79 4.82774C0.79 5.60774 0 7.20774 0 8.46774V15.3677C0 17.9177 2.07 19.9977 4.62 19.9977H15.4C17.95 19.9977 20.02 17.9277 20.02 15.3777V8.59774C20.02 7.24774 19.15 5.58774 18.05 4.81774ZM10.76 15.9977C10.76 16.4077 10.42 16.7477 10.01 16.7477C9.6 16.7477 9.26 16.4077 9.26 15.9977V12.9977C9.26 12.5877 9.6 12.2477 10.01 12.2477C10.42 12.2477 10.76 12.5877 10.76 12.9977V15.9977Z" fill="currentColor"/></svg>`,
  privilege: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.81141 2L5.19141 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.1914 2L18.8114 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 7.85156C2 6.00156 2.99 5.85156 4.22 5.85156H19.78C21.01 5.85156 22 6.00156 22 7.85156C22 10.0016 21.01 9.85156 19.78 9.85156H4.22C2.99 9.85156 2 10.0016 2 7.85156Z" stroke="currentColor" stroke-width="1.5"/><path d="M9.76172 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M14.3594 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
  reward: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.01172 11.2188V15.7087C3.01172 20.1987 4.81172 21.9987 9.30172 21.9987H14.6917C19.1817 21.9987 20.9817 20.1987 20.9817 15.7087V11.2188" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0005 12C13.8305 12 15.1805 10.51 15.0005 8.68L14.3405 2H9.67048L9.00048 8.68C8.82048 10.51 10.1705 12 12.0005 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.3108 12C20.3308 12 21.8108 10.36 21.6108 8.35L21.3308 5.6C20.9708 3 19.9708 2 17.3508 2H14.3008L15.0008 9.01C15.1708 10.66 16.6608 12 18.3108 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.63842 12C7.28842 12 8.77842 10.66 8.93842 9.01L9.15842 6.8L9.63842 2H6.58842C3.96842 2 2.96842 3 2.60842 5.6L2.33842 8.35C2.13842 10.36 3.61842 12 5.63842 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17C10.33 17 9.5 17.83 9.5 19.5V22H14.5V19.5C14.5 17.83 13.67 17 12 17Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  news: `<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.3 1.8C5.80125 1.8 5.4 2.20125 5.4 2.7V14.1C5.4 14.415 5.3475 14.7187 5.24625 15H16.5C16.9988 15 17.4 14.5987 17.4 14.1V2.7C17.4 2.20125 16.9988 1.8 16.5 1.8H6.3ZM2.7 16.8C1.2075 16.8 0 15.5925 0 14.1V3C0 2.50125 0.40125 2.1 0.9 2.1C1.39875 2.1 1.8 2.50125 1.8 3V14.1C1.8 14.5987 2.20125 15 2.7 15C3.19875 15 3.6 14.5987 3.6 14.1V2.7C3.6 1.2075 4.8075 0 6.3 0H16.5C17.9925 0 19.2 1.2075 19.2 2.7V14.1C19.2 15.5925 17.9925 16.8 16.5 16.8H2.7ZM7.2 4.5C7.2 4.00125 7.60125 3.6 8.1 3.6H9.9C10.3988 3.6 10.8 4.00125 10.8 4.5V6.3C10.8 6.79875 10.3988 7.2 9.9 7.2H8.1C7.60125 7.2 7.2 6.79875 7.2 6.3V4.5ZM12.9 5.4H14.7C15.1988 5.4 15.6 5.80125 15.6 6.3C15.6 6.79875 15.1988 7.2 14.7 7.2H12.9C12.4013 7.2 12 6.79875 12 6.3C12 5.80125 12.4013 5.4 12.9 5.4ZM8.1 8.4H14.7C15.1988 8.4 15.6 8.80125 15.6 9.3C15.6 9.79875 15.1988 10.2 14.7 10.2H8.1C7.60125 10.2 7.2 9.79875 7.2 9.3C7.2 8.80125 7.60125 8.4 8.1 8.4ZM8.1 11.4H14.7C15.1988 11.4 15.6 11.8012 15.6 12.3C15.6 12.7987 15.1988 13.2 14.7 13.2H8.1C7.60125 13.2 7.2 12.7987 7.2 12.3C7.2 11.8012 7.60125 11.4 8.1 11.4Z" fill="currentColor"/></svg>`,
  profile: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};

export default {
  name: "CrmBottomNavigation",
  data() {
    return {
      notchX: null
    };
  },
  computed: {
    couponCount() {
      return Number(this.$store.state.shortProfile.total_coupon_can_use || 0);
    },
    tabs() {
      return [
        {
          key: "home",
          label: this.$t("home"),
          route: "/profile",
          icon: NAV_ICONS.home
        },
        {
          key: "privilege",
          label: this.$t("privilege"),
          route: "/privilege",
          icon: NAV_ICONS.privilege,
          badge: this.couponCount
        },
        {
          key: "reward",
          label: this.$t("redeem_text"),
          route: "/reward",
          icon: NAV_ICONS.reward
        },
        {
          key: "news",
          label: this.$t("news"),
          route: "/news",
          icon: NAV_ICONS.news
        },
        {
          key: "profile",
          label: this.$t("profile"),
          route: "/manage",
          icon: NAV_ICONS.profile
        }
      ];
    },
    activeIndex() {
      const index = this.tabs.findIndex(tab => this.isActive(tab.route));
      return index >= 0 ? index : 0;
    },
    notchStyle() {
      if (this.notchX != null) {
        return { "--notch-x": `${this.notchX}px` };
      }
      const menuCount = this.tabs.length || 1;
      const itemWidth = 100 / menuCount;
      const activeCenter = itemWidth * this.activeIndex + itemWidth / 2;
      return { "--notch-x": `${activeCenter}%` };
    }
  },
  watch: {
    activeIndex() {
      this.$nextTick(() => this.updateNotchPosition());
    }
  },
  mounted() {
    this.$nextTick(() => this.updateNotchPosition());
    window.addEventListener("resize", this.updateNotchPosition);
    window.addEventListener("orientationchange", this.updateNotchPosition);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateNotchPosition);
    window.removeEventListener("orientationchange", this.updateNotchPosition);
  },
  methods: {
    isActive(route) {
      return this.$route.path.includes(route);
    },
    goTo(route) {
      if (this.$route.path != route) this.$router.push(route);
    },
    updateNotchPosition() {
      const nav = this.$refs.nav;
      const items = this.$refs.items;
      if (!nav || !items || !items.length) return;
      const activeBtn = items[this.activeIndex];
      if (!activeBtn) return;
      const navRect = nav.getBoundingClientRect();
      const itemRect = activeBtn.getBoundingClientRect();
      this.notchX = itemRect.left - navRect.left + itemRect.width / 2;
    }
  }
};
</script>

<template>
  <nav
    ref="nav"
    class="crm-bottom-nav"
    :style="notchStyle"
    data-test="nav-active-notch"
    aria-label="Standard V2 navigation"
  >
    <button
      v-for="tab in tabs"
      ref="items"
      :key="tab.key"
      type="button"
      :class="['crm-bottom-nav__item', { 'is-active': isActive(tab.route) }]"
      :data-test="`nav-tab-${tab.key}`"
      @click="goTo(tab.route)"
    >
      <span class="crm-bottom-nav__icon">
        <span
          v-html="tab.icon"
          class="crm-bottom-nav__svg"
          aria-hidden="true"
        />
        <span
          v-if="tab.badge > 0"
          class="crm-bottom-nav__badge"
          data-test="nav-privilege-badge"
        >
          {{ tab.badge }}
        </span>
      </span>
      <span class="crm-bottom-nav__dot" aria-hidden="true"></span>
      <span class="crm-bottom-nav__label">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<style lang="scss" scoped>
.crm-bottom-nav {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: stretch;
  --nav-x-padding: 10px;
  --notch-x: 50%;
  --notch-radius: 18px;
  min-height: calc(78px + env(safe-area-inset-bottom));
  overflow: visible;
  padding: 18px var(--nav-x-padding) calc(8px + env(safe-area-inset-bottom));
  background: transparent;
}

.crm-bottom-nav::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: #fff;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 -3px 2px rgba(0, 0, 0, 0.1);
  -webkit-mask: radial-gradient(
    circle var(--notch-radius) at var(--notch-x) 0,
    transparent 99%,
    #000 100%
  );
  mask: radial-gradient(
    circle var(--notch-radius) at var(--notch-x) 0,
    transparent 99%,
    #000 100%
  );
  pointer-events: none;
  transition: --notch-x 0.25s ease;
}

@property --notch-x {
  syntax: "<length-percentage>";
  inherits: true;
  initial-value: 50%;
}

@media (max-width: 360px) {
  .crm-bottom-nav {
    --notch-radius: 16px;
  }
}

.crm-bottom-nav__item {
  position: relative;
  z-index: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 0;
  background: transparent;
  color: #c7c7c7;
  font-size: var(--text-sm);
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  isolation: isolate;
}

.crm-bottom-nav__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.crm-bottom-nav__svg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}

.crm-bottom-nav__item.is-active {
  color: var(--primary-color);
}

.crm-bottom-nav__dot {
  position: absolute;
  top: -18px;
  left: 50%;
  z-index: 2;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  pointer-events: none;
  transform: translateX(-50%);
}

.crm-bottom-nav__item.is-active .crm-bottom-nav__dot {
  background: var(--primary-color);
}

.crm-bottom-nav__label {
  position: relative;
  z-index: 1;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crm-bottom-nav__badge {
  position: absolute;
  top: -6px;
  right: -10px;
  z-index: 2;
  min-width: 17px;
  height: 17px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--primary-color);
  color: #fff;
  font-size: var(--text-sm);
  line-height: 17px;
}
</style>
